(ns common.resource.roles
  (:require [common.db.effects.http :refer [jsonify]]
            [common.url :as url]
            [re-frame.core :as rf]))

(defn get-request-params
  [page search sort-direction]
  (cond-> {:pagesize 10}
    page (merge {:page (+ 1 (/ page 10))})
    sort-direction (merge {:sort
                           (str (when (= (:direction sort-direction) :desc) "-")
                                (name (:column sort-direction)))})
    (seq (:term search)) (merge {:filters
                                 (jsonify [["has"
                                            (:column search)
                                            (:term search)]])})))

(rf/reg-event-fx :resource.roles/get-all-roles
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)]
  (fn [{:keys [db config] :as cofx} _]
    {:db (assoc db :resource.roles/all {:state :pending :value []})
     :http
     {:method :get
      :uri (url/parts->str [(:apiUrl config) "api" "v0/roles"])
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.roles/get-all-success]
      :on-failure [:resource.roles/get-all-failure]}}))

(rf/reg-event-db :resource.roles/get-all-success
  (fn [db [_ roles]]
    (assoc db :resource.roles/all {:state :success
                                   :value roles})))

(rf/reg-event-db :resource.roles/get-all-failure
  (fn [db [_ _]]
    (assoc db :resource.roles/all {:state :failure :value []})))

(rf/reg-event-fx :resource.roles/get-all-paginated
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)]
  (fn [{:keys [db config] :as cofx} [_ page search sort-direction]]
    {:db (assoc db :resource.roles/paginated {:state :pending :value []})
     :http
     {:method :get
      :uri (url/parts->str [(:apiUrl config) "api" "v0/roles"])
      :params (get-request-params page search sort-direction)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.roles/get-all-paginated-success]
      :on-failure [:resource.roles/get-all-paginated-failure]}}))

(rf/reg-event-db :resource.roles/get-all-paginated-success
  (fn [db [_ roles]]
    (assoc db :resource.roles/paginated {:state :success
                                         :value (:_items roles)
                                         :meta (:_meta roles)})))

(rf/reg-event-db :resource.roles/get-all-paginated-failure
  (fn [db [_ _]]
    (assoc db :resource.roles/paginated {:state :failure :value []})))

(rf/reg-event-fx :resource.roles/post
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)]
  (fn [{:keys [db config] :as cofx} [_ payload]]
    {:db (assoc db :resource.roles/post {:state :pending})
     :http
     {:method :post
      :uri (url/parts->str [(:apiUrl config) "api" "v0/roles"])
      :params payload
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.roles/post-success]
      :on-failure [:resource.roles/post-failure]}}))

(rf/reg-event-db :resource.roles/post-success
  (fn [db _]
    (assoc db :resource.roles/post {:state :success})))

(rf/reg-event-db :resource.roles/post-failure
  (fn [db _]
    (assoc db :resource.roles/post {:state :failure})))

(rf/reg-event-fx :resource.roles/patch
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)]
  (fn [{:keys [db config] :as cofx} [_ role-id payload]]
    {:db (assoc db :resource.roles/patch {:state :pending})
     :http
     {:method :patch
      :uri (url/parts->str [(:apiUrl config) "api"
                            "v0/roles"
                            role-id])
      :params payload
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.roles/patch-success]
      :on-failure [:resource.roles/patch-failure]}}))

(rf/reg-event-db :resource.roles/patch-success
  (fn [db _]
    (assoc db :resource.roles/patch {:state :success})))

(rf/reg-event-db :resource.roles/patch-failure
  (fn [db _]
    (assoc db :resource.roles/patch {:state :failure})))

(rf/reg-event-fx :resource.roles/delete
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)]
  (fn [{:keys [db config] :as cofx} [_ role-id]]
    {:db (assoc db :resource.roles/patch {:state :pending})
     :http
     {:method :delete
      :uri (url/parts->str [(:apiUrl config) "api"
                            "v0/roles"
                            role-id])
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.roles/delete-success]
      :on-failure [:resource.roles/delete-failure]}}))

(rf/reg-event-db :resource.roles/delete-success
  (fn [db _]
    (assoc db :resource.roles/delete {:state :success})))

(rf/reg-event-db :resource.roles/delete-failure
  (fn [db _]
    (assoc db :resource.roles/delete {:state :failure})))

(rf/reg-sub :resource.roles/all
  (fn [db]
    (:resource.roles/all db)))

(rf/reg-sub :resource.roles/paginated
  (fn [db]
    (:resource.roles/paginated db)))
